import React from "react"
import { createPerformanceTableTool } from "@/editor/createPerformanceTableTool"

export const SmallPerformanceBySeriesTableTool = createPerformanceTableTool({
  type: "small_performance_by_series_table",
  headerText: "Performance by Series",
  columnHeader: "Series",
  dataProperty: "series",
  toolboxTitle: "Series Performance Table",
})
